module.exports = __webpack_public_path__ + "static/media/five.213b16a6.png";